/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";

import ClearIcon from "@mui/icons-material/Close";
import BackIcon from "@mui/icons-material/ArrowBack";
import LabelIcon from "@mui/icons-material/Label";
import Debounce from "../../../utils/Debounce";
import LoadingIcon from "../../Loading";

import "./MobileFilterPopup.css";
import { useIsComponentMounted } from "../../../hooks/useIsComponentMounted";

const debounce = new Debounce(1000);

const MobileFilterPopup = ({
  value,
  setValue,
  setOpen,
  placeholder,
  Icon,
  data,
}: {
  value: string;
  setValue: (value: string) => void;
  setOpen: (open: boolean) => void;
  placeholder: string;
  Icon?: any;
  data:
    | { options: { label: string; value: string }[]; getRecords?: undefined }
    | {
        getRecords: (v: string) => Promise<{ label: string; value: string }[]>;
        options?: undefined;
      };
}) => {
  const isComponentMounted = useIsComponentMounted();

  const [filter, setFilter] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState(data.options || []);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFilter("");
  }, []);

  // Filter static data
  useEffect(() => {
    if (!isComponentMounted) return;
    if (!data.options) return;

    if (!filter) {
      setFilteredOptions(data.options || []);
      return;
    }

    setFilteredOptions(
      data.options.filter((option) =>
        option.label.toLowerCase().includes(filter.toLowerCase())
      )
    );
  }, [data, filter, isComponentMounted]);

  // Dynamically get data
  useEffect(() => {
    if (!isComponentMounted) return; // Prevent loading records for previous search
    if (!data.getRecords) return;

    if (!filter) {
      return setFilteredOptions([]);
    }

    setIsLoading(true);
    debounce.clear();
    debounce.call(() => {
      data
        .getRecords(filter)
        .then((records) => {
          setFilteredOptions(records);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const [height, setHeight] = useState(window.visualViewport?.height || 20);
  useEffect(() => {
    window.visualViewport?.addEventListener("resize", () => {
      setHeight(window.visualViewport?.height || 20);
      // window.scrollTo(0, document.body.scrollHeight);
    });
  }, []);

  return (
    <div
      style={{
        height,
      }}
      className="mobileFilterPopup"
    >
      <div
        style={{
          padding: "16px 16px",
          paddingBottom: 16,
          borderBottom: "2px solid #d9d9d9",
        }}
      >
        <TextField
          key="nitroSearch"
          fullWidth
          autoFocus
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder={`Search for ${placeholder.toLowerCase()}`}
          InputProps={{
            style: {
              borderRadius: 12,
              padding: "0px 0px",
            },
            startAdornment: (
              <BackIcon
                className="onHoverNitro"
                style={{
                  cursor: "pointer",
                  padding: "8px 12px",
                  borderTopLeftRadius: 12,
                  borderBottomLeftRadius: 12,
                }}
                onClick={() => {
                  setFilter("");
                  setOpen(false);
                }}
              />
            ),
            endAdornment: filter ? (
              <ClearIcon
                className="onHoverNitro"
                style={{
                  cursor: "pointer",
                  padding: "8px 12px",
                  borderTopRightRadius: 12,
                  borderBottomRightRadius: 12,
                }}
                onClick={() => {
                  setFilter("");
                  setValue("");
                }}
              />
            ) : undefined,
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          flexBasis: 0,
          overflowY: "auto",
          padding: "10px 0px",
        }}
      >
        {isLoading && (
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingIcon color="#005CA6" height={100} width={100} />
          </div>
        )}

        {!isLoading &&
          filteredOptions
            .filter((r) => !!r.label)
            .map((option) => (
              <div
                key={option.value}
                className="onHoverNitro"
                onClick={() => {
                  setValue(option.value);
                  setOpen(false);
                }}
                style={{
                  height: 60,
                  minHeight: 60,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                  paddingLeft: 20,
                  margin: "0px 14px",
                  borderRadius: 12,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f1f1f1",
                    height: 40,
                    width: 40,
                    borderRadius: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {Icon || <LabelIcon style={{ color: "#383838" }} />}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: "#222222",
                  }}
                >
                  {option.label}
                </div>
              </div>
            ))}
      </div>
      {/* </div> */}
    </div>
  );
};

export default MobileFilterPopup;
